import { styled } from '@mui/material/styles'
import { Card } from 'settle-ui/components/Card/Card'

export const AuthCard = styled(Card)(({ theme }) => ({
  border: `1px solid ${theme.tokens.ThemeColorCommonOutline}`,
  background: theme.tokens.ThemeColorCommonSurface,
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '544px',
  minHeight: '480px',
  padding: theme.spacing(4),
}))
